import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { FaCheck, FaTimes } from 'react-icons/fa';

const Wrapper = styled.div<{ isChecked: boolean }>`
  display: flex;
  justify-items: center;
  gap: 4px;
  font-size: 15px;
  color: ${(prop) => (prop.isChecked ? colors.primaryGreen_500 : colors.BlueGray_600)};
  white-space: nowrap;
  float: left;
  margin: 2px 4px;
  line-height: 1em;
`;

interface IProps {
  title: string;
  code: number;
}

/**
 * 專利權登記事項標籤。
 */
const StatusTag: React.FC<IProps> = ({ title, code }) => {
  const isChecked = code !== 0;

  return isChecked ? (
    <Wrapper isChecked={isChecked}>
      <div title={'有' + title}>
        <FaCheck />
      </div>
      {title}
    </Wrapper>
  ) : (
    <Wrapper isChecked={isChecked}>
      <div title={'沒有' + title}>
        <FaTimes />
      </div>
      {title}
    </Wrapper>
  );
};

export default StatusTag;
